import Typography, {
	Size,
	TypographyProps,
} from "@components/WebsiteRevamp/Typography/Typography"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./CardsCategoryButton.module.scss"

type Props = {
	link: string
	data: CategoryModuleType
	modifier: string
	typograpyProps?: TypographyProps
}

const CardsCategoryButton = (props: Props) => {
	return (
		<object className={styles.additionalTextLink}>
			<Typography
				content={props.data.title}
				fontWeight={300}
				size={Size.XS}
				noPadding
				{...props.typograpyProps}
			/>
		</object>
	)
}

export default CardsCategoryButton
